module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img50.c2e17ea8.jpg";